import React, { useState, useEffect } from "react";
import Feedback from "./Feedback";
import {
  Button,
  GreenButton,
  RedButton
} from "../../../globals/components/button";
import styled from "styled-components";
import background from "../assets/background.png";
import trophy from "../assets/trophy.png";
import ribbon from "../assets/mult.png";
export default function GameResult({ ...props }) {
  const [showFeedback, setShowFeedback] = useState(false);
  const {
    feedback,
    questionFontSize,
    score,
    correct,
    incorrect,
    onRestartGame,
    onBack,
      speed,
      total
  } = props;

  let resultText = "";
  let rating = "";
  if (correct + incorrect < 6) {
    resultText =
      "We think you need to try again and try to answer a few more questions. If this is because you struggled with the questions, perhaps talk to your teacher. If this is because you were taking your time, perhaps you can try and speed up!";
    rating = "F";
  } else {
    if (score < 300) {
      resultText =
        "Good Attempt. Perhaps discuss the subject with your teacher to see if they know any hints and tips to help before trying again.";
      rating = "E";
    } else if (score >= 300 && score < 700) {
      resultText =
        "Good try. You are starting to understand the basics of the area and will soon have a good understanding. Perhaps try 2-3 more times and see how high a score you can get?";
      rating = "D";
    } else if (score >= 700 && score < 1100) {
      resultText =
        "Well done. You are showing a really good understanding in this area. Perhaps another go or 2 and you'll be achieving a perfect score!";
      rating = "C";
    } else if (score >= 1100 && score < 1500) {
      resultText =
        "Great job. You are really getting to grips with this subject area. Perhaps one more practise and you'll get a perfect score!";
      rating = "B";
    } else if (score >= 1500) {
      if (incorrect == 0)
        resultText = "Congratulations on getting a perfect score";
      else
        resultText = "Congratulations!"
      rating = "A";
    }
  }
  resultText = "";
  console.log(props);

  return (
    <ApplicationResult>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between"
        }}
      >
        <ResultImage>
          <div style={{ position: "relative", height: "300px" }}>
            <Banner>Well Done!</Banner>
          </div>
        </ResultImage>
        {showFeedback ? (
          <ResultText style={{ maxHeight: "500px", overflowY: "scroll" }}>
            Feedback
            <Feedback feedback={feedback} questionFontSize={questionFontSize} />
          </ResultText>
        ) : (
            <ResultText style={{ maxHeight: "700px", overflowY: "scroll" }}>

              <span>{resultText}</span>
              <ResultScores>

                <Result>

                  <div>Score:</div>
                  <ResultValue>{score}</ResultValue>
                  <div>Speed:</div>
                  <ResultValue>{speed}</ResultValue>
                  <div>Total Time:</div>
                  <ResultValue>{total}</ResultValue>
                  <Container>
                    <img
                      src={ribbon}
                      style={{
                        position: "relative",
                        top: "-100%",
                        right: "15%",
                        zIndex: "-1"
                      }}
                    >
                    </img>
                    <div className="centered">{props.placed}</div>
                  </Container>
                </Result>
                <Result>
                  <div style={{ color: "#42B231" }}>Correct:</div>
                  <ResultValue>{correct}</ResultValue>
                  <div style={{ color: "#EF3E37" }}>Incorrect:</div>
                  <ResultValue>{incorrect}</ResultValue>
                </Result>

              </ResultScores>
              {props.isRating && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    border: "solid #e4e4e4 2px",
                    marginTop: "20px"
                  }}
                >
                  <span style={{ fontSize: "0.6em" }}>Rating</span>
                  <div style={{ fontSize: "1.2em" }}>{rating}</div>
                </div>
              )}

            </ResultText>
          )}
      </div>

      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <RedButton
          onClick={onBack}
          style={{
            width: "40%",
            height: "60px",
            fontSize: "30px",
            margin: "20px"
          }}
        >
          Back
        </RedButton>
        {feedback !== undefined && (
          <GreenButton
            onClick={() => setShowFeedback(!showFeedback)}
            style={{
              width: "40%",
              height: "60px",
              fontSize: "30px",
              margin: "20px"
            }}
          >
            {showFeedback ? "Hide Feedback" : "Show Feedback"}
          </GreenButton>
        )}
      </div>
    </ApplicationResult>
  );
}

const ApplicationResult = styled.div`
  height: 100%;
  z-index: -10;
  background: #fff;
  background-image: url(${background});
  padding: 40px;
  font-size: 3em;
  border: solid 2px #683d8c;
  display: flex;
  flex-direction: column;
  justify-content: start;
`;

const ResultScores = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 30px;
  flex-direction: column;
  z-index: -2;
`;

const Result = styled.div`
  display: flex;
  margin-top: 20px;
  height:60px;
`;
const ResultValue = styled.div`
  margin: 0px 20px;
  border: solid #e4e4e4 2px;
  background: #fff;
  padding: 0px 15px;
  height: 50px;
`;

const ResultText = styled.div`
  background: #fff;
  border: solid #683d8c 2px;
  width: 50%;
  border-radius: 10px;
  padding: 10px;
  color: #683d8c;
  font-weight: 600;
  font-size: 1.2em;
  z-index: 1;
`;

const ResultImage = styled.div`
  width: 40%;
  background-image: url(${trophy});
  background-size: auto;
  background-repeat: no-repeat;
  background-position: top;
  display: flex;
  flex-direction: column;
  align-self: center;
`;

const Banner = styled.div`
  position: absolute;
  left: 50%;
  display: block;
  margin: 100px -200px;
  width: 400px;
  height: 60px;
  border: 1px solid #e88f12;
  font: normal 30px/60px;
  line-height: 60px;
  font-weight: 600;
  text-align: center;
  color: #fff;
  background: rgba(255, 186, 32, 1);
  border-radius: 4px;
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.15) inset, 0 6px 10px rgba(0, 0, 0, 0.15);
  &::before,
  ::after {
    content: "";
    position: absolute;
    z-index: -1;
    left: -70px;
    top: 24px;
    display: block;
    width: 40px;
    height: 0px;
    border: 30px solid #e88f12;
    border-right: 20px solid #c97e11;
    border-bottom-color: #e88f12;
    border-left-color: transparent;
    transform: rotate(-5deg);
  }

  &::after {
    left: auto;
    right: -70px;
    border-left: 20px solid #c97e11;
    border-right: 30px solid transparent;
    transform: rotate(5deg);
  }
`;

const Container = styled.div`
  text-align: center;
  color: white;
  position: relative

  .centered {
    position: absolute;
    top: 35%;
    left: -15%;
    width: 100%
    text-align: center
    font-size 2em;
    //50%

  }

  .img{
    width: 100%;
    height: auto;
  }

`
